import { render } from "./Designees.vue?vue&type=template&id=55a3724e"
import script from "./Designees.vue?vue&type=script&lang=js"
export * from "./Designees.vue?vue&type=script&lang=js"

import "./Designees.vue?vue&type=style&index=0&id=55a3724e&lang=css"

import exportComponent from "/var/www/localhrm.apcwo.org/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__